export default __webpack_public_path__ + "static/media/icon-facebook.851d0ee5.svg";